module.exports = __webpack_public_path__ + "img/vlm.5a954b8d.png";